import React, { useEffect } from 'react';
import GoogleIcon from 'components/ui/icons/GoogleIcon';

/**
 * GoogleAdsSuccess Component
 * 
 * Displays a success message when Google Ads OAuth is completed successfully.
 * Sends a success message to the parent window which will close this popup.
 * 
 * Usage: This component is typically rendered in a popup window after successful OAuth.
 */
const GoogleAdsSuccess = () => {
  useEffect(() => {
    // Send success message to parent window
    if (window.opener) {
      window.opener.postMessage({
        type: 'GOOGLE_AUTH_SUCCESS',
        timestamp: Date.now()
      }, window.location.origin);
    }
  }, []);

  return (
    <div 
      style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        margin: 0,
        background: 'white',
        color: '#333'
      }}
    >
      {/* Logo */}
      <img 
        src="/ch3.png" 
        alt="Espor.ai" 
        style={{
          height: '60px',
          width: 'auto',
          marginBottom: '2rem'
      }}
      />
      
      <div style={{
        textAlign: 'center',
        padding: '2rem',
        background: '#f8f9fa',
        borderRadius: '12px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e9ecef'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '1rem'
        }}>
          <GoogleIcon width={48} height={48} />
        </div>
        <h1 style={{
          margin: '0 0 1rem 0',
          fontSize: '1.8rem',
          color: '#28a745'
        }}>
          ¡Google Ads Conectado!
        </h1>
        <p style={{
          margin: '0 0 2rem 0',
          opacity: 0.8,
          fontSize: '1rem',
          color: '#6c757d'
        }}>
          Tu cuenta de Google Ads ha sido conectada exitosamente.
        </p>
        <div style={{
          fontSize: '0.9rem',
          opacity: 0.6,
          color: '#6c757d'
        }}>
          Esta ventana se cerrará automáticamente...
        </div>
      </div>
    </div>
  );
};

export default GoogleAdsSuccess; 